


































































































































































import Vue from 'vue';
import {Prop, Component, Watch, Emit} from 'vue-property-decorator';
import {Vozilo} from "@/services/BackendProxies";
import dataProxy from '@/services/data-proxy.service';
import { ValidationObserver } from 'vee-validate';
import {Action, Mutation, State} from "vuex-class";
import {TabBase} from "@/views/Vozila/PodaciVozila/TabBase";

@Component({})
export default class Tab1 extends TabBase {
    async onSave() {
        const isValid = await (<any>this.$refs.form).validate();
        if (isValid) {
            super.save();
        }
    }

    created() {
        this.$nextTick(() => {
            (<any>this.$refs.form).validate();
        });
    }

    bojeVozila = async (params, success, failure) => {
        const boje = await dataProxy.vratiBojeVozila(params.data.term);
        success(boje);
    };
}
